/**
 * @author michalstolarski
 * @since 2024-5-15
 */

import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { useResize } from "@hooks/useResize";

import { Props } from "./OptionAccordion.types";
import * as Styled from "./OptionAccordion.styled";

export const OptionAccordion: React.FC<Props> = (props): React.ReactElement => {
  const [maxHeight, setMaxHeight] = React.useState<number>(0);
  const $content = React.useRef<HTMLDivElement>(null);
  const fallbackId = React.useId();
  const { windowWidth } = useResize();

  const id = props.id ?? fallbackId;

  React.useEffect(() => {
    if (!$content.current) return;

    setMaxHeight($content.current.scrollHeight);
  }, [$content, windowWidth, props.checked]);

  return (
    <TestWrapper testId={props.testId}>
      <Styled.Root
        htmlFor={id}
        checked={props.checked}
        disabled={props.disabled}
      >
        <Styled.Header>
          <Styled.Radio
            id={id}
            name={props.name}
            checked={props.checked}
            value={props.value}
            onChange={props.onChange}
          />

          <Styled.Title>{props.title}</Styled.Title>
        </Styled.Header>

        <Styled.Body
          $maxHeight={maxHeight}
          $checked={props.checked}
          $disabled={props.disabled}
        >
          <div ref={$content}>{props.children}</div>
        </Styled.Body>
      </Styled.Root>
    </TestWrapper>
  );
};
